<template>
    <ModalComponent
        :name="'editar-sesion-' + sesion.id"
        :title="'Editar sesión con fecha: ' + sesion.fecha"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
                    
            <FormSesion :sesion="sesion" :evento="evento"/>

            <div class="row">
                <div class="col-12">
                    <Button id="editar-sesion" type="submit" name="button">Editar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>

    import FormSesion from '@/components/backend/eventos/sesiones/FormSesion';
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['sesion', 'evento'],
        data() {
            return {
            }
        },
        methods: {
            close(editado) {
                this.$emit('close', 'editar-sesion-' + this.sesion.id, editado);
            },
            editarSesion() {
                this.sesion.filters = {};
                this.sesion.sesion_id = this.sesion.id;
                this.sesion.evento_id = this.evento.id;
                this.sesion.fecha = moment(this.sesion.fecha_zulu).format('YYYY-MM-DD HH:mm:ss');
                this.sesion.end_session_date = moment(this.sesion.end_session_date).format('YYYY-MM-DD HH:mm:ss');
                if (this.sesion.fecha_cierre_venta) {
                    this.sesion.fecha_cierre_venta = moment(this.sesion.fecha_cierre_venta).format('YYYY-MM-DD HH:mm:ss');
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.editar'), this.sesion).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.editarSesion();
                }
            },
        },
        components: {
            FormSesion, ModalComponent
        }
    }
</script>
